// Habillage « Mes tâches » (DA — DESIGN.md §8 ter « board Kanban multi-vues »).
// PRÉSENTATION PURE : aucune donnée, aucun handler, aucun calcul métier. Ce
// module ne fait que CHOISIR des couleurs / libellés d'affichage à partir de
// l'état déjà résolu par taches-logic.js. Il ne persiste rien et ne décide
// d'aucun comportement (le drag, les filtres et le CRUD restent dans le logic).

import { DS } from '../../lib/ui'
import { dueBucket, formatDue } from './taches-logic'

// ── Couleurs d'ÉTAT (signaux, pas des teintes-catégorie — cf. DESIGN §2) ──
// Pastille ronde 9px en tête de colonne (vue Statuts) + pastille de statut
// portée par la carte dans les autres vues.
export const STATUS_DOT = {
  todo:  DS.ciel,     // À faire = ciel
  doing: DS.warning,  // En cours = ambre
  done:  DS.success,  // Fait = vert
}

export const STATUS_PILL = {
  todo:  { bg: DS.cielSoft,   fg: DS.marine },
  doing: { bg: DS.warningBg,  fg: DS.warningText },
  done:  { bg: DS.successBg,  fg: DS.successText },
}

// ── Pastille d'en-tête « urgence » des colonnes de la vue Par échéance ──
export const ECHEANCE_DOT = {
  today: DS.corail,   // Aujourd'hui = corail
  week:  DS.warning,  // Cette semaine = ambre
  later: DS.ciel,     // Plus tard = ciel
  none:  DS.textMuted, // Sans échéance = gris
}

// ── Chip d'échéance porteuse de la couleur (corail today / ambre bientôt /
// danger retard / gris lointain). Sélection de COULEUR uniquement : le libellé
// vient de formatDue, l'horizon de dueBucket (tous deux dans le logic). ──
function dueTone(dueAt) {
  if (!dueAt) return null
  const due = dueAt instanceof Date ? dueAt : new Date(dueAt)
  if (Number.isNaN(due.getTime())) return null
  const now = new Date()
  const startToday = new Date(now.getFullYear(), now.getMonth(), now.getDate())
  const startTomorrow = new Date(startToday)
  startTomorrow.setDate(startTomorrow.getDate() + 1)
  if (due.getTime() < startToday.getTime()) return 'late'
  if (due.getTime() < startTomorrow.getTime()) return 'today'
  return dueBucket(dueAt) === 'week' ? 'soon' : 'far'
}

const DUE_TONE_STYLE = {
  late:  { bg: DS.dangerBg,   fg: DS.dangerText },
  today: { bg: DS.corailSoft, fg: DS.corailText },
  soon:  { bg: DS.warningBg,  fg: DS.warningText },
  far:   { bg: '#eef1f4',     fg: DS.textSecondary },
}

export function dueChip(dueAt, allDay) {
  const label = formatDue(dueAt, allDay)
  if (!label) return null
  const tone = dueTone(dueAt)
  return { label, ...(DUE_TONE_STYLE[tone] || DUE_TONE_STYLE.far) }
}

// ── Initiales d'avatar (Fraunces, fond ciel) — présentation ──
export function initialsFrom(name) {
  if (!name) return ''
  const parts = String(name).trim().split(/\s+/).filter(Boolean)
  if (!parts.length) return ''
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
  return (parts[0][0] + parts[1][0]).toUpperCase()
}

// ── Retire un emoji de tête d'un libellé hérité du logic (les libellés de
// scope spéciaux y portent encore un emoji ; en DA on préfixe une icône
// lucide à la place). Aucune modification du logic. ──
export function stripLeadEmoji(s) {
  if (typeof s !== 'string') return s
  return s.replace(/^\s*[\p{Extended_Pictographic}‍️]+\s*/u, '').trim()
}

// Fond de colonne gris (cartes blanches qui ressortent — profondeur).
export const COLUMN_BG = '#f1f2f4'
